/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enums_Sociaalemotioneeldomein_Moreelkompas5Inputs */

const nl_enums_sociaalemotioneeldomein_moreelkompas5 = /** @type {(inputs: Enums_Sociaalemotioneeldomein_Moreelkompas5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Moreel kompas`)
};

/**

* @param {Enums_Sociaalemotioneeldomein_Moreelkompas5Inputs} inputs
* @param {{ locale?: "nl" }} options
* @returns {LocalizedString}
*/
const enums_sociaalemotioneeldomein_moreelkompas5 = /** @type {((inputs?: Enums_Sociaalemotioneeldomein_Moreelkompas5Inputs, options?: { locale?: "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enums_Sociaalemotioneeldomein_Moreelkompas5Inputs, { locale?: "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return nl_enums_sociaalemotioneeldomein_moreelkompas5(inputs)
});
export { enums_sociaalemotioneeldomein_moreelkompas5 as "enums.SociaalEmotioneelDomein.MoreelKompas" }